import React, { useMemo } from 'react';
import { Product } from 'shared/types/product/Product';
import { Variant } from 'shared/types/product/Variant';
import Dropdown from 'components/commercetools-ui/atoms/dropdown';
import { getEmptyLabel, getSelectedBundleLabel } from 'helpers/utils/bundlesItems';
import ProductPrice from './product-price';

type Props = {
  bundles?: Product[];
  selectedBundles: Variant[];
  onBundleSelect: (i: number, sku: string) => void;
};

const Bundles: React.FC<Props> = ({ bundles, selectedBundles, onBundleSelect }) => {
  const handleBundleSelect = (index: number, e: React.ChangeEvent<HTMLSelectElement>) => {
    onBundleSelect(index, e.target.value);
  };

  const variants = useMemo(() => {
    return selectedBundles.filter((item) => item);
  }, [selectedBundles]);
  return (
    <div className="mt-12 flex w-full flex-col">
      {bundles?.map((bundle, i) => (
        <div key={bundle.productId} className="mt-8 flex flex-col">
          <div className="flex items-center gap-6">
            <span className="capitalize">Choose your subscription plan</span>
            {variants.length > 0 && <ProductPrice variants={variants} inModalVersion />}
          </div>
          <div className="mt-4">
            <Dropdown
              className="h-full rounded-sm"
              defaultValue=""
              items={[{ label: 'One Time', value: '' }].concat(
                bundle.variants.map((variant) => ({
                  label: getSelectedBundleLabel(variant, 'subscription'),
                  value: variant.sku,
                })),
              )}
              onChange={(e) => handleBundleSelect(i, e)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Bundles;
